/**
 *
 * Mensagens de Alerta
 * http://dev.inema.ba.gov.br/QUALIDADE/normas-procedimentos/blob/master/qualidade/PMDS_Padrao_Interface_Sistemas.md#msg_a01-campo-obrigat%C3%B3rio
 *
 * Mensagens de Confirmação
 * http://dev.inema.ba.gov.br/AMBIENTAL/GEOBAHIA/produto/Geobahia/documentacao/blob/master/01.Requisito/Lista_Mensagens_Novo_Geobahia.md#12-mensagens-de-confirma%C3%A7%C3%A3o
 *
 * Mensagens de Informação
 * http://dev.inema.ba.gov.br/AMBIENTAL/GEOBAHIA/produto/Geobahia/documentacao/blob/master/01.Requisito/Lista_Mensagens_Novo_Geobahia.md#14-mensagens-de-informa%C3%A7%C3%A3o
 * 
 * Mensagens de Sucesso
 * http://dev.inema.ba.gov.br/AMBIENTAL/GEOBAHIA/produto/Geobahia/documentacao/blob/master/01.Requisito/Lista_Mensagens_Novo_Geobahia.md#15-mensagens-de-sucesso
 */

const MSG_A01 = 'Campo obrigatório!',
  MSG_A04 = 'Formato de e-mail inválido!',
  MSG_A10 = 'Senha inválida.',
  MSG_A11 = 'Dados inválidos.',
  MSG_A15 = 'Usuário inativo no SIGA! Favor entrar em contato com o suporte.',
  MSG_A16 = 'Usuário inativo no Geobahia! Favor entrar em contato com o suporte.',
  MSG_A26 = 'Usuário sem permissão para acessar o sistema! Favor entrar em contato com o suporte.',
  MSG_A36 = 'Login informado não encontrado.',
  MSG_A37 = 'Login ou Senha inválido!',
  MSG_C01 = 'Deseja inserir este registro?',
  MSG_C02 = 'Deseja excluir este registro?',
  MSG_C03 = 'Deseja alterar este registro?',
  MSG_E04 = (userName) => `Não é possível inserir mais de uma permissão para o usuário ${userName}.`,
  MSG_E05 = 'Envio não realizado!',
  MSG_I01 = 'Registro já existente na base de Dados!',
  MSG_I04 = 'Somente usuários cadastrados na rede do Inema poderão ter acesso ao sistema.',
  MSG_S03 = 'Registro alterado com sucesso!',
  MSG_S04 = 'Registro excluído com sucesso!',
  MSG_S07 = 'Usuário cadastrado com sucesso!',
  MSG_S08 = 'Permissão inserida com sucesso',
  MSG_S09 = 'Enviado com sucesso!',
  MSE_A18 = 'Usuário deve inserir apenas letras minúsculas.',
  MSE_S01 = 'Módulo cadastrado com sucesso!',
  MSE_S02 = 'Módulo editado com sucesso!';

export default {
  MSG_A01,
  MSG_A04,
  MSG_A10,
  MSG_A11,
  MSG_A15,
  MSG_A16,
  MSG_A26,
  MSG_A36,
  MSG_A37,
  MSG_C01,
  MSG_C02,
  MSG_C03,
  MSG_E04,
  MSG_E05,
  MSG_I01,
  MSG_I04,
  MSG_S03,
  MSG_S04,
  MSG_S07,
  MSG_S08,
  MSG_S09,
  MSE_A18,
  MSE_S01,
  MSE_S02
};

export {
  MSG_A01,
  MSG_A04,
  MSG_A10,
  MSG_A11,
  MSG_A15,
  MSG_A16,
  MSG_A26,
  MSG_A36,
  MSG_A37,
  MSG_C01,
  MSG_C02,
  MSG_C03,
  MSG_E04,
  MSG_E05,
  MSG_I01,
  MSG_I04,
  MSG_S03,
  MSG_S04,
  MSG_S07,
  MSG_S08,
  MSG_S09,
  MSE_A18,
  MSE_S01,
  MSE_S02
};
